import type { Action, ActiveBattle, Battle, Zone } from '@mezha/api'
import { baseApi } from '../baseApi'

export const battlesApi = baseApi.injectEndpoints({
  endpoints: b => ({
    activeBattle: b.query<ActiveBattle, void>({ query: () => ({ get: '/api/v1/battles/active' }), providesTags: ['ActiveBattle'] }),
    battle: b.query<Battle, string>({ query: id => ({ get: `/api/v1/battles/${id}` }), providesTags: (_r, _e, id) => [{ type: 'Battle', id }] }),
    choose: b.mutation<Battle, { id: string; round: number; target?: string; attack?: Zone; defend: Zone; action: Action; skill?: string; defend2?: Zone; ally?: string }>({
      query: ({ id, ...body }) => ({ command: `/api/v1/battles/${id}/choice`, body }),
      onQueryStarted: async ({ id }, { queryFulfilled, dispatch }) => {
        const { data } = await queryFulfilled
        dispatch(battlesApi.util.upsertQueryData('battle', id, data))
      },
    }),
    forfeit: b.mutation<Battle, { id: string }>({
      query: ({ id }) => ({ command: `/api/v1/battles/${id}/forfeit` }),
      onQueryStarted: async ({ id }, { queryFulfilled, dispatch }) => {
        const { data } = await queryFulfilled
        dispatch(battlesApi.util.upsertQueryData('battle', id, data))
        dispatch(baseApi.util.invalidateTags(['ActiveBattle', 'Hero']))
      },
    }),
  }),
})

export const { useActiveBattleQuery, useBattleQuery, useChooseMutation, useForfeitMutation } = battlesApi
